import { ArrowUpRight } from "lucide-react";
import { siteConfig, waHref, imgSrc, imgSrcSet } from "@/config/siteConfig";
import { trackEvent } from "@/lib/analytics";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";

export const Services = () => (
  <section id="hizmetler" data-testid="services-section" className="scroll-mt-20 bg-paper py-20 md:py-28">
    <div className="mx-auto max-w-6xl px-5">
      <SectionHeading
        eyebrow="Hizmetlerimiz"
        title="Profesyonel Araç Taşıma Çözümleri"
        desc="Binek araçtan iş makinesine kadar her araç tipi için gerçek ekipmanla hizmet veriyoruz. Kartlara dokunarak WhatsApp'tan hızlıca yazabilirsiniz."
        testid="services-heading"
      />
      <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {siteConfig.services.map((s, i) => {
          const Icon = s.icon;
          return (
            <Reveal key={s.title} delay={(i % 3) * 0.07}>
              <a
                href={waHref(`Merhaba, ${s.title.toLocaleLowerCase("tr")} hizmeti almak istiyorum. Konumumu sizinle paylaşıyorum.`)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`service-card-${i}`}
                onClick={() => trackEvent("whatsapp_click", "services")}
                className="group relative block h-full rounded-2xl border border-ink-100 bg-white p-4 shadow-sm transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1 hover:border-brand/30 hover:shadow-xl"
              >
                <div className="relative">
                  <img
                    src={imgSrc(s.image, 800)}
                    srcSet={imgSrcSet(s.image)}
                    sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 400px"
                    alt={s.imageAlt}
                    loading="lazy"
                    decoding="async"
                    style={{ objectPosition: s.position }}
                    className="aspect-[16/10] w-full rounded-xl object-cover"
                  />
                  <span className="absolute -bottom-5 left-4 grid h-11 w-11 place-items-center rounded-full border-4 border-white bg-brand text-white shadow-lg">
                    <Icon className="h-5 w-5" aria-hidden="true" />
                  </span>
                </div>
                <div className="px-1.5 pb-2 pt-8">
                  <h3 className="font-display text-[17px] font-bold leading-snug text-ink-900">{s.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-neutral-500">{s.desc}</p>
                  <span className="mt-3.5 inline-flex items-center gap-1.5 text-xs font-bold text-wa-dark">
                    <WhatsAppIcon className="h-3.5 w-3.5" />
                    WhatsApp'tan Yaz
                    <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" aria-hidden="true" />
                  </span>
                </div>
              </a>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
